module.exports = __webpack_public_path__ + "static/media/smoothing-light.0abf1b0d.svg";